import { useQuery } from '@tanstack/react-query';
import { getRoles } from '../api/ROLES/roles';

export const useGetRolesWithPermissions = () => {
    return useQuery({
        queryKey: ['roles'],
        queryFn: getRoles,
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
};
